import { Link, Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useFitnessProfileContext } from "../context/FitnessProfileContext.jsx"

import "../styles/pageStyles/dashboardStyles.css"


export default function UserMainDashboard() {

    const { currentProfile, isLoading } = useFitnessProfileContext()
    const [streakInfo, setStreakInfo] = useState({})
    const [completedChallengeToday, setCompletedChallengeToday] = useState(false)

    function getPreviousDate(dateString) {
        const [year, month, day] = dateString.split("-").map(Number)

        const date = new Date(Date.UTC(year, month - 1, day))

        date.setUTCDate(date.getUTCDate() - 1)

        return date.toISOString().slice(0, 10)
    }

    function getHoursUntilMidnight(timezone) {
        const now = new Date()

        const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        }).formatToParts(now)

        const getPart = type =>
            Number(parts.find(part => part.type === type).value)

        const hours = getPart("hour")
        const minutes = getPart("minute")
        const seconds = getPart("second")

        const secondsRemaining =
            (23 - hours) * 60 * 60 +
            (59 - minutes) * 60 +
            (60 - seconds)

        return {
            hours: Math.floor(secondsRemaining / 3600),
            minutes: Math.floor((secondsRemaining % 3600) / 60),
        }
    }

    function getDisplayedStreak(streakFromDatabase, lastChallengeCompletedAt, timezone) {
        // We can't determine the streak without these values
        if (!lastChallengeCompletedAt || !timezone) {
            return {
                streak: 0,
                streakAtRisk: false,
                hoursRemaining: 0,
                minutesRemaining: 0,
            }
        }

        const now = new Date()

        const formatter = new Intl.DateTimeFormat("en-CA", {
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })

        const today = formatter.format(now)

        console.log("today is: ", today)

        const lastCompletedDate = formatter.format(
            new Date(lastChallengeCompletedAt)
        )

        console.log("lastCompletedDate is: ", lastCompletedDate)

        // Calculate yesterday in the user's timezone
        const yesterdayDate = getPreviousDate(today)


        console.log("yesterday is: ", yesterdayDate)

        // Completed today
        if (lastCompletedDate === today) {
            setCompletedChallengeToday(true)
            console.log("yep was completed today")
            return {
                streak: streakFromDatabase,
                streakAtRisk: false,
                hoursRemaining: 0,
                minutesRemaining: 0,
            }
        }

        console.log("compairing last completed tp yesterday (should equal): ", lastCompletedDate, yesterdayDate)

        // Completed yesterday
        if (lastCompletedDate === yesterdayDate) {
            const timeRemaining = getHoursUntilMidnight(timezone)
            console.log("I should see this", timeRemaining)
            return {
                streak: streakFromDatabase,
                streakAtRisk: timeRemaining.hours <= 6 ? true : false,
                hoursRemaining: timeRemaining.hours,
                minutesRemaining: timeRemaining.minutes,
            }
        }

        // Streak has expired
        console.log("streak set to 0")
        return {
            streak: 0,
            streakAtRisk: false,
            hoursRemaining: 0,
            minutesRemaining: 0,
        }
    }

    useEffect(() => {
        if (currentProfile) {
            console.log("running streak check")
            setStreakInfo(getDisplayedStreak(currentProfile?.currentStreak, currentProfile?.lastChallengeCompletedAt, currentProfile?.timezone))
            console.log("streakInfo: ", streakInfo)
        }

    }, [currentProfile])

    if (isLoading || !currentProfile) {
        return (
            <div>Loading skeleton component here...</div>
        )
    } else {
        return (
            <div >
                <p className='page-title'>dashboard</p>
                <p>current user: {currentProfile?.displayName ? currentProfile.displayName : currentProfile.userId}</p>
                <p>level: {currentProfile?.currentLevel}</p>
                {streakInfo.streak > 0 && <p>streak: {streakInfo.streak}</p>}
                <br></br>
                {completedChallengeToday ? <div>Today's challenge completed! Check out your exercise history</div> : <Link to="/todays-challenge">Complete today's challenge page</Link>}
                <p>start a new workout -</p>
                <Link to="/edit-daily-routine">customize daily routine</Link>
                {completedChallengeToday ? <div>true</div> : <div>false</div>}
                {streakInfo.streakAtRisk && <div>complete today's challenge in the next {streakInfo.hoursRemaining ? `${streakInfo.hoursRemaining} hours` : `${streakInfo.minutesRemaining} minutes`} so you don't lose your streak!</div>}
            </div>
        )
    }
}